module.exports = __webpack_public_path__ + "images/bug_wine_red_size_6_cd6d426b16b8db4a98dac32e4bf9d3e3.png";